import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { GlobalService } from './../services/global.service';
import { HttpService } from './../services/http.service';
import { AmlWorkspace } from './../models/amlWorkspace.model';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MLService } from './../services/ml-service';
import { AlertComponent } from '../common/alert/alert.component';

@Component({
  selector: 'app-mlservices',
  templateUrl: './mlservices.component.html',
  styleUrls: ['./mlservices.component.css']
})
export class MlservicesComponent implements OnInit {

  resourceGroups;
  selectedResourceGroup;
  workspaceList;
  url;
  selectedUrl;
  constructor(
    public globals: GlobalService,
    public httpService: HttpService,
    public mlService: MLService,
    public router: Router,
    public _router: ActivatedRoute,
    public dialog: MatDialog
  ) { }

  ngOnInit() {
    this.getResourceGroups();
  }

  getResourceGroups() {
    this.mlService.getResourceGroups().subscribe(resourceGroups => {
      this.resourceGroups = resourceGroups;
    },error=>{ console.log(error)});
  }
  getMLWorkspaceList(resourceGroup) {
    this.mlService.getAmlWorkspaces(resourceGroup).subscribe(workspaceList => {
      this.workspaceList = workspaceList;
    },error=>{ console.log(error)});
  }

  redirectToML() {
    if (this.selectedUrl != undefined) {
      let modelListUrl = this.selectedUrl.replace('ml.azure.com/', "ml.azure.com/model/list/");
      window.open(modelListUrl);
    }
  }
  openDialog(): void {
    this.dialog.open(AmlModalComponent, {
      width: '80%',
      height: 'auto',
      panelClass: 'confirm-modalbox-dark',
      data: {}
    });
  }

  onSelectWorkspace(ws) {
    this.selectedUrl = ws.url;
  }

  onSelectResourceGroup(resourceGroup) {
    this.getMLWorkspaceList(resourceGroup.name);
  }
}

@Component({
  selector: 'modal-component',
  templateUrl: './aml-modal.component.html',
  styleUrls: ['./aml-modal.component.css']
})

export class AmlModalComponent {
  isLoader = false;
  isCompleted = false;
  loaderMessage = "Creating Workspace. Please wait...";
  locationList;
  resourceGroups;
  keyVaults;
  storageAccounts;
  containerRegistries;
  applicationInsights;
  workspaceNameAvailable = true;
  Heading = "Create AML Workspace";
  workspaceData = new AmlWorkspace();
  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<AmlModalComponent>,
    public httpService: HttpService,
    public globals: GlobalService,
    public mlService: MLService

  ) { };

  ngOnInit() {
    this.getResourceGroups();
    this.getLocationList();
    this.getWorkspaceEditionList();
  }

  loadAllChildResources(resourceGroupName) {
    this.resetChildFResoucesList();
    this.getKeyVaults(resourceGroupName);
    this.getStorageAccounts(resourceGroupName);
    this.getContainerRegistries(resourceGroupName);
    this.getApplicationInsights(resourceGroupName);
  }

  resetChildFResoucesList() {
    this.workspaceData.storageAccountId = undefined;
    this.workspaceData.storAcctName = undefined;
    this.workspaceData.applicationInsightName = undefined;
    this.workspaceData.keyVaultId = undefined;
    this.workspaceData.keyVaultName = undefined;
    this.workspaceData.containerRegistryId = undefined;
    this.workspaceData.containerRegistryName = undefined;
    this.workspaceData.applicationInsightId = undefined;
    this.workspaceData.applicationInsightName = undefined;
  }

  getResourceGroups() {
    this.mlService.getResourceGroups().subscribe(resourceGroups => {
      this.resourceGroups = resourceGroups;
    }, (error) => {
      console.log(error);
    });
  }
  getWorkspaceEditionList() {
    this.workspaceData.workspaceEdition = "Basic";
  }
  getLocationList() {
    this.mlService.getLocations().subscribe(locData => {
      this.locationList = locData;
    }, (error) => {
      console.log(error);
    });
  }

  getKeyVaults(resourceGroupName) {
    this.mlService.getKeyVaults(resourceGroupName).subscribe(kv => {
      this.keyVaults = kv;
    }, (error) => {
      console.log(error);
    });
  }

  getStorageAccounts(resourceGroupName) {
    this.mlService.getStorageAccounts(resourceGroupName).subscribe(sa => {
      this.storageAccounts = sa;
    }, (error) => {
      console.log(error);
    });
  }

  getContainerRegistries(resourceGroupName) {
    this.mlService.getContainerRegistries(resourceGroupName).subscribe(res => {
      this.containerRegistries = res;
    }, (error) => {
      console.log(error);
    });
  }
  getApplicationInsights(resourceGroupName) {
    this.mlService.getApplicationInsights(resourceGroupName).subscribe(res => {
      this.applicationInsights = res;
    }, (error) => {
      console.log(error);
    });
  }
  checkWorkspaceNameAvailability() {
    this.mlService.getAmlWorkspace(this.workspaceData.resourceGroupName, this.workspaceData.workspace).subscribe((res: any) => {
      if (res.length > 0) {
        this.workspaceNameAvailable = false;
      }
      else {
        this.workspaceNameAvailable = true;
      }
    }, (error) => {
      console.log(error);
    });
  }

  setSelectedProperty(item, itemProperty, targetObj, targetpropertyName) {
    targetObj[targetpropertyName] = item[itemProperty];
  }

  onCancelClick(): void {
    this.dialogRef.close("Cancel");
  }

  showAlert(data: { success: boolean; message: string; }) {
    this.dialog.open(AlertComponent, {
      width: '350px',
      panelClass: 'confirm-modalbox-dark',
      height: 'auto',
      data: data
    });
  }

  addWorkspace() {
    this.isLoader = true;
    this.loaderMessage = "Creating Workspace. It may take upto 10-15 seconds. Please wait...";
    this.workspaceData.createdBy = this.globals.loggedInUser;
    this.mlService.CreateMLWorkspace(this.workspaceData).subscribe((result: any): void => {
      if (result.status != undefined && result.status == 200) {
        this.showAlert({ success: true, message: "AML Workspace " + this.workspaceData.workspace + " has been created successfully." });
      }
      else
      {
        this.showAlert({ success: false, message: "Something went wrong while creating AML Workspace " + this.workspaceData.workspace + ". Please try again." });
      }
      this.isLoader = false;
      this.dialogRef.close();
    },error=>{console.log(error)});
  }
}
